import React, { useState, useEffect } from 'react';

// Import CSS & assets & components
import ico_arrow_pagination from '../../../assets/ico/ico_arrow_pagination.svg';
import sort_up from '../../../assets/ico/ico_sort_up.svg';
import sort_down from '../../../assets/ico/ico_sort_down.svg';
import ResultItem from './ResultItem';

const paginationSize = 10;
var filteredList_var = [];

const ResultsList = ({ searchParameters, setHighlightedLand }) => {

    const [filteredList, setFilteredList] = useState({ list: [], update_trigger: "0" });
    const [paginationCurrent, setPaginationCurrent] = useState(0);
    const [paginationMax, setPaginationMax] = useState(0);
    const [paginationUI, setPaginationUI] = useState(1);
    const [paginatedList, setPaginatedList] = useState({ list: [], update_trigger: "0" });
    const [sortKey, setSortKey] = useState("id_down");

    const handleSortChange = (newSortKey) => {
        if (sortKey === newSortKey + "_down") {
            setSortKey(newSortKey + "_up");
        }
        // else if (sortKey === newSortKey + "_up") {
        //     setSortKey("id_down");
        // }
        else {
            setSortKey(newSortKey + "_down");
        }
    }
    useEffect(() => {
        create_filtered_list(filteredList_var, sortKey);
    }, [sortKey]);

    const handlePaginationChange = (pageNum) => {
        var pagination_target = parseInt(pageNum) - 1;
        console.log("PAGINATION GO TO", pagination_target);
        if (pagination_target !== paginationCurrent && pagination_target >= 0 && pagination_target < paginationMax) {
            var pagination_start = pagination_target * paginationSize;
            var pagination_end = pagination_start + 10;
            console.log(pagination_start + " to " + pagination_end);
            var paginatedList_var = filteredList_var.slice(pagination_start, pagination_end);
            console.log("paginatedList", paginatedList_var);
            setPaginatedList({ list: paginatedList_var, update_trigger: Date.now().toString() });
            setPaginationCurrent(pagination_target);
            setPaginationUI(pagination_target + 1);
        }
    }

    useEffect(() => {
        console.log("RESULT LIST UPDATE", searchParameters);
        if (searchParameters?.result_list?.list && searchParameters.result_list.list.length > 0) {
            create_filtered_list(searchParameters.result_list.list, sortKey);
        }
        else {
            var trigger = Date.now().toString();
            setFilteredList({ list: [], update_trigger: trigger });
            setPaginationCurrent(0);
            setPaginationUI(1);
            setPaginationMax(0);
            setPaginatedList({ list: [], update_trigger: trigger });
        }
    }, [searchParameters?.result_list?.update_trigger]);

    const create_filtered_list = (original_list, sort_key) => {
        var trigger = Date.now().toString();
        filteredList_var = JSON.parse(JSON.stringify(original_list));
        var sort_params = sort_key.split("_");
        var sort_label = sort_params[0];
        var sort_direction = sort_params[1];
        console.log("SORT ON", sort_label, sort_direction);
        filteredList_var.sort(function (a, b) {
            var valueA = a[sort_label];
            var valueB = b[sort_label];
            if (sort_direction === "down") {
                return (valueA < valueB) ? -1 : (valueA > valueB) ? 1 : 0;
                // return b[sort_label] - a[sort_label];
            }
            else {
                return (valueA < valueB) ? 1 : (valueA > valueB) ? -1 : 0;
                // return a[sort_label] - b[sort_label];
            }
        })
        filteredList_var.forEach((element, element_index) => {
            element.i = element_index;
        });
        console.log("filteredList", filteredList_var);
        // console.log(Math.ceil(filteredList_var.length / paginationSize));
        var paginatedList_var = filteredList_var.slice(0, paginationSize);
        // console.log("paginatedList", paginatedList_var);
        setFilteredList({ list: filteredList_var, update_trigger: trigger });
        setPaginationCurrent(0);
        setPaginationUI(1);
        setPaginationMax(Math.ceil(filteredList_var.length / paginationSize));
        setPaginatedList({ list: paginatedList_var, update_trigger: trigger });
    }

    return (
        <div className="app__sectiondata__widget">
            <div className="app__sectiondata_widget_title">Liste des parcelles</div>
            <div className="app__search_result_titles_container">
                <div className="app__search_result_item_col00"></div>
                <div className="app__search_result_item_col0" style={{ cursor: 'pointer' }} onClick={() => { handleSortChange("id") }}>Parcelle
                    {sortKey === "id_down" ?
                        <img className="app__search_result_item_col0_ico" src={sort_down} />
                        : sortKey === "id_up" ?
                            <img className="app__search_result_item_col0_ico" src={sort_up} />
                            : ""}
                </div>
                {(searchParameters?.filters && Object.keys(searchParameters.filters).length > 0) &&
                    <>
                        {Object.keys(searchParameters.filters).map((filter_key, filter_index) => {
                            return (
                                <div key={'filter_label_' + filter_index} className="app__search_result_item_col0" style={{ cursor: 'pointer' }} onClick={() => { handleSortChange(searchParameters.filters[filter_key]?.format?.key || "id_down") }}>
                                    {searchParameters.filters[filter_key]?.format?.label}
                                    {sortKey === searchParameters.filters[filter_key]?.format?.key + "_down" ?
                                        <img className="app__search_result_item_col0_ico" src={sort_down} />
                                        : sortKey === searchParameters.filters[filter_key]?.format?.key + "_up" ?
                                            <img className="app__search_result_item_col0_ico" src={sort_up} />
                                            : ""}
                                </div>
                            )
                        })}
                    </>
                }
            </div>
            {paginatedList?.list && paginatedList.list.length > 0 &&
                <>
                    {paginatedList.list.map(item => {
                        return (
                            <ResultItem item_data={item} setHighlightedLand={setHighlightedLand} filters={searchParameters?.filters || null} />
                        )
                    })}
                </>
            }
            {(searchParameters?.result_list?.list && searchParameters.result_list.list.length > 10) &&
                <div className="app__search_result_pagination">
                    <div className="app__search_result_pagination_container">
                        <div className={`app__search_result_pagination_button_left ${paginationCurrent === 0 ? "app__search_result_pagination_button_hidden" : ""}`} onClick={() => { handlePaginationChange(paginationCurrent) }}><img src={ico_arrow_pagination} /></div>
                        <div className="app__search_result_pagination_num_current">
                            {/* {paginationCurrent + 1} */}
                            <input className="app__search_result_pagination_num_input" type="number" id="search_result_pagination_num_input" name="search_result_pagination_num_input" min="1" max={paginationMax + 1} step="1" defaultValue="1" value={paginationUI} onChange={(e) => { setPaginationUI(e.target.value) }} onBlur={(e) => { handlePaginationChange(e.target.value) }} onKeyUp={(e) => { if (e.key === "Enter") { document.getElementById('search_result_pagination_num_input').blur() } }}></input>
                        </div>
                        <div className="app__search_result_pagination_button_right" onClick={() => { handlePaginationChange(paginationCurrent + 2) }}><img src={ico_arrow_pagination} /></div>
                    </div>
                </div>
            }
        </div>
    );
};

export default ResultsList;